// extracted by mini-css-extract-plugin
export default {"container":"style_container__uMUVA","title":"style_title__HUndm","divider":"style_divider__oKpxM","children":"style_children__wGFca","formFooter":"style_formFooter__cy4-M"};